
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useEmailTemplates = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchTemplates = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase
        .from('email_templates')
        .select('*')
        .order('created_at');
      
      if (error) throw error;
      return data;
    } catch (error: any) {
      toast.error('Failed to fetch email templates', { 
        description: error.message 
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const saveTemplate = async (
    type: string, 
    htmlContent: string, 
    textContent: string
  ) => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase
        .from('email_templates')
        .update({ 
          html_content: htmlContent, 
          text_content: textContent 
        })
        .eq('type', type)
        .select();
      
      if (error) throw error;
      
      toast.success('Template updated successfully');
      return data;
    } catch (error: any) {
      toast.error('Failed to save email template', { 
        description: error.message 
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    fetchTemplates,
    saveTemplate,
    isLoading
  };
};
